// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/generative_ai/agents" endpoint
 */
import fetch from "@lib/fetch";
import type { Queries } from "@lib/serializeQueryObjects";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAgents } from "./constants";
import type { GenerativeAiAgentsParams, GenerativeAiAgentsResult } from "./types";
import { isGenerativeAiAgentsResult } from "./validators";

export const getDataTableGenerativeAiAgents = reactQueryTableFetcherAdapter(
  generativeAiAgents,
  (
    signal: AbortSignal,
    { appGroupId, query = {}, groupby, limit = 20, start = 0, sortdir, sortby }: GenerativeAiAgentsParams
  ): Promise<GenerativeAiAgentsResult> => {
    return fetch(
      "/generative_ai/agents",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query as Queries),
      },
      { signal }
    );
  },
  isGenerativeAiAgentsResult
);
